
const eventDetails = [
  {
    path: '',
    name: 'event',
    meta: {
      breadcrumb: 'Event',
      title: ''
    },
    component: () => import('@/components/Event/Index'),
  },
  {
    path: 'tickets',
    meta: {
      breadcrumb: 'tickets'
    },
    component: () => import('@/components/Event/components/EventIndexPage'),
    props: true,
    children: [
      {
        path: '/',
        name: 'tickets',
        component: () => import('@/components/Event/Details/Tickets'),
        props: true
      },
      {
        path: ':ticketId',
        component: () => import('@/components/Event/Details/Ticket'),
        props: true,
        children: [
          {
            path: '',
            name: 'ticket',
            component: () => import('@/components/Event/Details/SeatsIO'),
            props: true
          },
          {
            path: 'payment',
            name: 'payment',
            component: () => import('@/components/Event/Details/Payments'),
            props: true
          },
          {
            path: 'payment/:paymentMethod/:response',
            name: 'event-payment-confirmation',
            component: () => import('@/components/Event/Details/Payments'),
            props: true
          },
        ]
      }
    ]
  }
];
export default eventDetails;
